export const buildWebsitePublication = (product, fees, options = {}) => {
    const base = options.price ?? product.regular_price;
    const price = Number(base);
    const deliveryFees = Number(fees || 0);
    if (base === '' || base === null || base === undefined || !Number.isFinite(price) || price < 0
        || !Number.isFinite(deliveryFees) || deliveryFees < 0) {
        throw new Error('Le prix et les frais de livraison doivent être des montants positifs ou nuls.');
    }
    const vase = options.vaseInclusion ?? product.vase_inclusion ?? 'unspecified';
    if (!['unspecified', 'included', 'not_included'].includes(vase)) throw new Error('Option vase invalide.');
    const delivery = options.websiteDelivery ?? product.website_delivery ?? {};
    const express = delivery.express_enabled === true;
    return {
        price: Math.round((price + deliveryFees) * 100) / 100,
        vase_inclusion: vase,
        website_delivery: {
            express_enabled: express,
            express_zones: express && Array.isArray(delivery.express_zones) ? delivery.express_zones : [],
            morocco_enabled: delivery.morocco_enabled === true,
        },
    };
};

export const websitePublicationMeta = (product) => {
    const delivery = product.website_delivery || {};
    return [
        { key: '_pegasus_vase_inclusion', value: product.vase_inclusion || 'unspecified' },
        { key: '_pegasus_delivery_express_enabled', value: delivery.express_enabled === true ? '1' : '0' },
        { key: '_pegasus_delivery_express_zones', value: JSON.stringify(delivery.express_enabled === true ? delivery.express_zones || [] : []) },
        { key: '_pegasus_delivery_morocco_enabled', value: delivery.morocco_enabled === true ? '1' : '0' },
    ];
};
